import { memo, type PropsWithChildren } from 'react';

import { cn } from '@air/utils-tailwind';

export type AncestorImageContainerProps = {
  backgroundColor: string;
  className?: string;
};

export const AncestorImageContainer = memo(
  ({ backgroundColor, children, className }: PropsWithChildren<AncestorImageContainerProps>) => {
    return (
      <div
        className={cn('mr-1 -ml-1 flex size-5 items-center justify-center rounded-4', className)}
        style={{ backgroundColor }}
      >
        {children}
      </div>
    );
  },
);

AncestorImageContainer.displayName = 'AncestorImageContainer';
